export default function Spinner({ size = 24, className = "" }) {
  return (
    <div
      className={`inline-block border-2 border-border border-t-dark rounded-full animate-spin ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
